module.exports = __webpack_public_path__ + "a17e1ab1538772004fbca1b961103d28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/chubb_us_2023_chart.png
// module id = 1655
// module chunks = 0